export default __webpack_public_path__ + "static/media/zoom.5543ae5a.svg";